'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_ExternalDocumentsListResponseItem(id, essentialInfo, version, createdById, createdBy, createdAt, totalAmount) {
  this.wC = null;
  this.Kz = null;
  this.Xu = 0;
  this.Xs = null;
  this.Xr = null;
  this.Ky = null;
  this.Xt = null;
  this.wC = id;
  this.Kz = essentialInfo;
  this.Xu = version;
  this.Xs = createdById;
  this.Xr = createdBy;
  this.Ky = createdAt;
  this.Xt = totalAmount;
}
export { $c_Lapp_api_ExternalDocumentsListResponseItem as $c_Lapp_api_ExternalDocumentsListResponseItem };
$p = $c_Lapp_api_ExternalDocumentsListResponseItem.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_ExternalDocumentsListResponseItem;
/** @constructor */
function $h_Lapp_api_ExternalDocumentsListResponseItem() {
}
export { $h_Lapp_api_ExternalDocumentsListResponseItem as $h_Lapp_api_ExternalDocumentsListResponseItem };
$h_Lapp_api_ExternalDocumentsListResponseItem.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_ExternalDocumentsListResponseItem)) {
    var x = this.wC;
    var x$2 = x$0.wC;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Kz;
      var x$4 = x$0.Kz;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.Xu === x$0.Xu))) {
      var x$5 = this.Xs;
      var x$6 = x$0.Xs;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.Xr === x$0.Xr))) {
      var x$7 = this.Ky;
      var x$8 = x$0.Ky;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.Xt;
      var x$10 = x$0.Xt;
      return ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 7;
});
$p.t = (function() {
  return "ExternalDocumentsListResponseItem";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.wC;
      break;
    }
    case 1: {
      return this.Kz;
      break;
    }
    case 2: {
      return this.Xu;
      break;
    }
    case 3: {
      return this.Xs;
      break;
    }
    case 4: {
      return this.Xr;
      break;
    }
    case 5: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDateTime(this.Ky);
      break;
    }
    case 6: {
      return this.Xt;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "essentialInfo";
      break;
    }
    case 2: {
      return "version";
      break;
    }
    case 3: {
      return "createdById";
      break;
    }
    case 4: {
      return "createdBy";
      break;
    }
    case 5: {
      return "createdAt";
      break;
    }
    case 6: {
      return "totalAmount";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_ExternalDocumentsListResponseItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iw)));
}
export { $isArrayOf_Lapp_api_ExternalDocumentsListResponseItem as $isArrayOf_Lapp_api_ExternalDocumentsListResponseItem };
var $d_Lapp_api_ExternalDocumentsListResponseItem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_ExternalDocumentsListResponseItem, "app.api.ExternalDocumentsListResponseItem", ({
  iw: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_ExternalDocumentsListResponseItem as $d_Lapp_api_ExternalDocumentsListResponseItem };
//# sourceMappingURL=app.api.-External-Documents-List-Response-Item.js.map
